import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=0812ad5f&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=0812ad5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0812ad5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0812ad5f')) {
      api.createRecord('0812ad5f', component.options)
    } else {
      api.reload('0812ad5f', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=0812ad5f&scoped=true&", function () {
      api.rerender('0812ad5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8fRnqRO5PF26x/JS/comp/CookieBox.vue"
export default component.exports